// src/utils/cookies.js
export const setCookie = (name, value, options = {}) => {
  let cookieString = `${name}=${value}; path=/`;
  
  if (options.expires) {
    const d = new Date();
    d.setTime(d.getTime() + options.expires * 24 * 60 * 60 * 1000);
    cookieString += `; expires=${d.toUTCString()}`;
  }
  
  console.log("Setting cookie:", cookieString); // Debugging
  document.cookie = cookieString;
};

export const getCookie = (name) => {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [key, value] = cookie.split('=');
    if (key === name) return value;
  }
  return null;
};
